module.exports = __webpack_public_path__ + "static/media/op.06512593.png";